/**
 * <s-carousel> — single-row scroll carousel.
 * Expects a [data-track] scroller plus [data-prev] / [data-next] buttons.
 * Buttons scroll by roughly one visible page and disable at the ends.
 */
class SCarousel extends HTMLElement {
  #ac;

  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.prev?.addEventListener('click', () => this.#go(-1), { signal });
    this.next?.addEventListener('click', () => this.#go(1), { signal });
    this.track.addEventListener('scroll', () => this.#update(), { signal, passive: true });
    window.addEventListener('resize', () => this.#update(), { signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #go(direction) {
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    const amount = this.track.clientWidth * 0.9 * direction * (rtl ? -1 : 1);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: amount, behavior: reduce ? 'auto' : 'smooth' });
  }

  #update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const pos = Math.abs(this.track.scrollLeft);
    const scrollable = max > 2;
    this.toggleAttribute('data-scrollable', scrollable);
    if (this.prev) this.prev.disabled = !scrollable || pos <= 2;
    if (this.next) this.next.disabled = !scrollable || pos >= max - 2;
  }
}

if (!customElements.get('s-carousel')) customElements.define('s-carousel', SCarousel);
